/*
 * Created by alex@hackerbay.com on 5.2.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

function getNetzAssistentUrl(){
    return "https://www.vodafone.de/netz-assistent/?i=440a74705f5b70f8a1e93139fb1d1012&c=DSL&a=069&p=c4dba61d0852705795994fadb71acfe4&r=onboarding&c_id=onboarding"
}

function openNetzAssistent(){
    window.open(getNetzAssistentUrl());
}

function getVodafoneHilfeUrl(){
    return "https://www.vodafone.de/privat/hilfe.html"
}

function openVodafoneHilfe(){
    window.open(getVodafoneHilfeUrl());
}


export {openNetzAssistent, getNetzAssistentUrl, openVodafoneHilfe}